import { styled } from "@mui/material";
import React, { useEffect } from "react";
import disableScroll from "disable-scroll";
import { selectPageLoading } from "../../../store/slices/loadingSlice";
import { useAppSelector } from "../../../store/hooks";
import LoadingBox from "./LoadingBox";

const BackDrop = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.33)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
});

export default function LoadingFullPage() {
  const isPageLoading = useAppSelector(selectPageLoading);
  useEffect(() => {
    disableScroll[!isPageLoading ? "off" : "on"]();
  }, [isPageLoading]);
  return (
    <>
      {isPageLoading && (
        <BackDrop>
          <LoadingBox />
        </BackDrop>
      )}
    </>
  );
}
